module.exports = __webpack_public_path__ + "img/logo_dzpps_serbia.311dc498.jpg";